export { default } from './SectionContent';